import type { ILocation } from "@/interfaces/api/location.interface"
import { BaseLocation } from "@/models/base-location.model.ts"

export class Location extends BaseLocation implements ILocation {
  public static className = "Location"
  public static verboseName = "Locatie"

  instructionFeedbackActivity: string

  name: string | null
  isTenantBase: boolean

  public constructor(location: ILocation) {
    super(location)

    this.instructionFeedbackActivity = location.instructionFeedbackActivity

    this.name = location.name
    this.isTenantBase = location.isTenantBase ?? false
  }
}
